'use client';

import dynamic from 'next/dynamic';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

const DynamicTestPanel = dynamic(() => import('@packages/modules/src/TestPanel/TestPanel.client'), {
  ssr: false,
});

export const TestPanelLoader = () => {
  const searchParams = useSearchParams();
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (window.location.href.indexOf('empirie.dev') > 0 && !searchParams?.get('skipTP')) {
      setShouldRender(true);
    }
  }, [searchParams]);

  if (!shouldRender) {
    return null;
  }

  return <DynamicTestPanel />;
};
